export default __webpack_public_path__ + "static/media/hero-header-bg.43300dcb.png";